import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  De_signGeneralAttestationDocumentInput,
  useDeSignGeneralAttestationMutation as useDeSignGeneralAttestationMutationType,
} from "@/modules/patients/detail/general-attestation/de/services/__generated__/useDeSignGeneralAttestationMutation.graphql"

const mutation = graphql`
  mutation useDeSignGeneralAttestationMutation($input: De_signGeneralAttestationDocumentInput!) {
    de_signGeneralAttestationDocument(input: $input) {
      de_GeneralAttestation {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...deGeneralAttestationsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignGeneralAttestationMutationType>, "variables"> & {
  id: De_signGeneralAttestationDocumentInput["id"]
}

const useDeSignGeneralAttestationMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignGeneralAttestationMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignGeneralAttestationMutation }
